<div
  [class]="canManageReport() ? '' : 'opacity-50'"
  class="bg-proffeo-surface-toolbar flex w-full justify-between gap-2 rounded-lg border-opacity-10"
>
  <!-- Time column -->
  <div class="bg-proffeo-surface-on flex flex-col gap-0.5 rounded-l-lg p-2 w-[68px] items-center justify-center">
    <span class="text-lg font-semibold text-proffeo-on-action opacity-75">
      {{ report().dateFrom | proffeoDate: defaultTimeFormat }}
    </span>
    <span class="text-lg font-semibold text-proffeo-on-action">
      {{ report().dateTo | proffeoDate: defaultTimeFormat }}
    </span>
  </div>

  <!-- Content -->
  <div class="flex w-full items-center justify-between">
    <div class="flex h-full max-w-[175px] flex-col justify-center py-2">
      <p class="text-proffeo-text truncate text-base">
        {{ report().user()?.firstName + ' ' + report().user()?.lastName }}
      </p>
      <p class="text-proffeo-text truncate text-sm">{{ report().description }}</p>
    </div>
    <div class="flex h-[68px] min-h-[68px] flex-col items-center justify-center gap-1 rounded-r-lg p-2">
      <div class="flex gap-2">
        <p class="text-proffeo-text">{{ report().duration | intlDuration }}</p>
        @if (canManageReport()) {
          <mat-icon
            [matMenuTriggerFor]="matTaskCardMenu"
            fontIcon="more_vert"
            class="cursor-pointer"
          />
        }
      </div>
    </div>
  </div>
</div>

<mat-menu #matTaskCardMenu="matMenu">
  <button
    (click)="onEditTimeReportCardClick(report())"
    mat-menu-item
  >
    <mat-icon
      fontIcon="edit"
      class="mr-2"
    />
    {{ 'reports-work-time-report-actions-menu-edit-report' | translate }}
  </button>

  <button
    (click)="onDeleteTimeReportCardClick(report())"
    mat-menu-item
  >
    <mat-icon
      fontIcon="delete"
      class="mr-2"
    />
    {{ 'reports-work-time-report-actions-menu-delete-report' | translate }}
  </button>
</mat-menu>